import AdjustOutlined from "@mui/icons-material/AdjustOutlined";
import CheckCircleOutlineRounded from "@mui/icons-material/CheckCircleOutlineRounded";
import { Skeleton } from "@mui/material";
import { SubmissionStepState } from "hooks/useSubmissionSteps";

export const SubmissionStepStatusIcon = ({ status }: { status?: SubmissionStepState }) => {
  switch (status) {
    case SubmissionStepState.NotStarted:
    case SubmissionStepState.InProgress:
    case SubmissionStepState.Invalid:
      return <AdjustOutlined color="action" />;
    case SubmissionStepState.Done:
      return <CheckCircleOutlineRounded color="success" />;
    case undefined:
      return <Skeleton variant="circular" width={20} height={20} />;
    default:
      ((_: never) => {
        throw new Error(`Unexpected value: ${_}`);
      })(status);
  }
};
